import React, { useEffect, useState } from 'react';
import styles from './StartEarlier.module.css';
import { Modal, Button, ConfigProvider } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import store from '../../../store';
import { loadUser } from '../../../Actions/Auth';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import Helper from '../../../Utils/Helper';
import StripePayment from '../../../StripePayment/StripePayment';
import { toast } from 'react-toastify';
import { FaMoon } from 'react-icons/fa';

const StartEarlier = ({ user,userGroups, usersFreeChargingLocations, booking, updateTrigger,location, userAvgPower }) => {
    // console.log("Location",location)
    // console.log("booking in start early", booking)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }));

    const [newFromDate, setNewFromDate] = useState(() => {
        const date = new Date();
        date.setSeconds(0, 0);
        return date;
    });

    const [updatedWallet, setUpdatedWallet] = useState([]);
    const [userLoading, setUserLoading] = useState(false);
    const [futureEstimate, setFutureEstimate] = useState(null);
    const [walletRechargeModal, setWalletRechargeModal] = useState(false);

    const [showError, setShowError] = useState(false);
    const [availableChargers, setAvailableChargers] = useState([])
    const [selectedCharger, setSelectedCharger] = useState(booking.connector._id)
    const [nightChargeAvailableConnectorIDs, setNightChargeAvailableConnectorIDs] = useState([])
    const [nightChargeEstimate, setNightChargingEstimate] = useState(0)


    useEffect(() => {
        if( availableChargers.length !== 0) {
            const availableChargerIds = availableChargers.map(c => c._id);
            if (!availableChargerIds.includes(booking.connector._id)) {
                setSelectedCharger(availableChargers[0]._id);
            }
    }
    }, [availableChargers]);

    const calculateEstimatedAmount = (totalTimeInSec, startTime, endTime, isCustomEnergyRateForSelectedLocation, customEnergyRate) => {
        // console.log("Available chargers",availableChargers)
        // console.log("selected Charger", selectedCharger,booking.charger._id)
        let charger = availableChargers.filter((c) => 
            String(c._id) === String(selectedCharger) 
        );
        // console.log("selected connector data: ",  charger)
        // let chargerData = charger.charger
        // console.log("charger data; ", chargerData)
        // chargerData.connector = charger
        if(charger.length === 0){
            let chargerData = booking.charger
            chargerData.connector = [booking.connector]
            charger = [chargerData]
        }else{
            console.log("connector data: ", charger)
            let chargerData = charger[0].charger
            chargerData.connector = [charger[0]]
            charger = [chargerData]

        }
        
        // charger = charger.length === 0 ? [booking.charger] : charger
        // if(charger.length === 0){
        //     charger[0].connector = [booking.connector]
        // }
        
        console.log("charger",charger)
        const onGoingBookingEstimate = Helper.calculateEstimatedAmount(totalTimeInSec, startTime, endTime, charger[0].connector[0]._id, false, isCustomEnergyRateForSelectedLocation, customEnergyRate, null, charger, [booking.charger.location], 0, false, userAvgPower, booking.isNightCharging);
        return onGoingBookingEstimate;
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }));

            setNewFromDate(() => {
                const date = new Date();
                date.setSeconds(0, 0);
                return date;
            });

        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (booking && isModalVisible && !userLoading) {
            if (futureEstimate !== null) {

                setShowError(false);
                let {isFreeCharging, customEnergyRate, isCustomEnergyRateForSelectedLocation} = Helper.checkUserGroupPermissions(userGroups, booking?.charger?.location?._id,  usersFreeChargingLocations)
                const { estimateAmount, endTime, endTimeOverNight } = booking;
                const userWallet = user?.wallet?.coins;
                const lockedAmtWithoutThisBooking = futureEstimate - estimateAmount;
                const timeDifferenceInMinutes = (new Date(booking.isNightCharging ? endTimeOverNight : endTime) - new Date(newFromDate)) / (1000 * 60);
                const timeDifferenceInSeconds = (new Date(booking.isNightCharging ? endTimeOverNight : endTime) - new Date(newFromDate)) / (1000);

                let { estimateAmount: updatedEstimateAmount } = isFreeCharging ? { estimateAmount: 0 } : calculateEstimatedAmount(timeDifferenceInMinutes, new Date(newFromDate), new Date(booking.isNightCharging ? endTimeOverNight : endTime), isCustomEnergyRateForSelectedLocation, customEnergyRate);
                let nightChargeAmount = 0;
                if(booking.isNightCharging && nightChargeAvailableConnectorIDs.includes(selectedCharger)){
                    nightChargeAmount = booking.nightChargeEstimate;
                }
                setNightChargingEstimate(nightChargeAmount);
                updatedEstimateAmount += nightChargeAmount;
                const updatedLockedAmt = lockedAmtWithoutThisBooking + updatedEstimateAmount;
                const newWalletAmt = userWallet - updatedLockedAmt;
                const newEstimateAmountUpdated = updatedEstimateAmount - estimateAmount;

                setUpdatedWallet({
                    estimateAmount,
                    futureEstimate,
                    withoutThisBookingWallet: futureEstimate + estimateAmount,
                    updatedEstimateAmount,
                    newEstimateAmountUpdated,
                    timeDifferenceInMinutes,
                    timeDifferenceInSeconds,
                    newFromDate,
                    endTime,
                    newWalletAmt
                })

            }
            else {
                setShowError(true);
            }

        }
    }, [isModalVisible, booking, currentTime, userLoading, user,selectedCharger]);


    useEffect(() => {
        const fetchData = async () => {
            if (booking && isModalVisible) {
                setUserLoading(true);
                try {
                    await store.dispatch(loadUser());
                    const lockedAmt = await BreathAPIs.getTotalFutureEstimate();
                    setFutureEstimate(lockedAmt?.data)
                } catch (error) {
                    console.error("Error loading user:", error);
                } finally {
                    setUserLoading(false);
                }
            }
        };

        fetchData();
    }, [isModalVisible, booking]);


    const showModal = () => {
        setIsModalVisible(true);
    };

    useEffect(()=>{
        const fetchAvailableChargers = async()=>{
            try {
                console.log("calling api ")
                const availableChargers = await BreathAPIs.getAvailableChargers(booking._id,location._id, new Date())
                console.log("Available Chargers",availableChargers)
                setAvailableChargers(availableChargers?.data?.connectors)
                if(booking.isNightCharging){
                    let connectorIDList = availableChargers.data.connectors.map((conn)=> conn._id)
                    let response = await BreathAPIs.getAvailableNightChargeConnectors(booking.startTime, booking.endTime, connectorIDList)
                    console.log('respnose for night charge connectos: ', response.data)
                    let nightChargeIDs = response.data
                    nightChargeIDs.push(booking.connector._id)
                    setNightChargeAvailableConnectorIDs(nightChargeIDs)
                }
            } catch (error) {
                console.log(error)
            }
            
        }
        fetchAvailableChargers()
    },[isModalVisible])

    const [isSubmitting, setIsSubmitting] = useState(false)
    const handleOk = async () => {   
        setIsSubmitting(true)
        try {
            const startEarlyActionCreatedAt = new Date();
            const result = await BreathAPIs.updateBookingTime(
                booking._id, 
                updatedWallet.updatedEstimateAmount,
                updatedWallet.timeDifferenceInSeconds,
                updatedWallet.newFromDate,
                selectedCharger,
                startEarlyActionCreatedAt,
                nightChargeEstimate
            );
            console.log('API result:', result);
    
            if (result?.status === 200) {
                toast.success(result?.data?.success?.msg || 'Booking updated successfully');
                console.log('Update successful');
                updateTrigger && updateTrigger();
            } else {
                toast.error(result?.data?.errors?.msg || 'Failed to update booking');
            }
            setIsSubmitting(false)
        } catch (error) {
            console.error('Error updating booking time:', error);
            toast.error('An unexpected error occurred');
            setIsSubmitting(false)
        }
        finally {
            setIsSubmitting(false)
        }
    
        setIsModalVisible(false);
    };
    

    const handleCancel = () => {
        console.log('Canceled starting earlier');
        setSelectedCharger(booking.connector._id)
        // calculateEstimatedAmount(3600);
        setIsModalVisible(false);
    };

    if (user?.isGuest) {
        return null;
    }

    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: '#18365E',
                colorBgContainer: '#ffffff',
                boxShadow: 'none'
            },
        }}>
            <div className={styles['start-earlier-container']}>
                <button className={styles['start-earlier']} onClick={showModal}>
                    Do you want to start earlier?
                </button>

                {isModalVisible && <Modal
                    title="Start early?"
                    open={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    okText="Update"
                    cancelText="Cancel"
                    okButtonProps={{
                        disabled: (userLoading || (updatedWallet?.newWalletAmt <= 0 && !user?.isAutoPayEnabled) || showError || availableChargers.length === 0),
                        loading: isSubmitting,
                    }}
                >
                    {userLoading ?
                        <div>
                            <p className={`card-text placeholder-glow`}>
                                <span className="placeholder col-12 rounded"></span>
                            </p>
                            <p className={`card-text placeholder-glow`}>
                                <span className="placeholder col-8 rounded-pill"></span>
                            </p>
                        </div>
                        :

                        <div className={styles['start-earlier-content']}>
                            {showError ?

                                <div className={`${styles['danger']} text-center`}>
                                    Something went wrong !
                                </div>
                                :
                                <>
                                    <p>You may be assigned a new charger based on current availability.</p>
                                    <div>
                                        Charger : 
                                       {console.log("available chargers: ", availableChargers)}
                                       {console.log("booking connector: ", booking?.connector)}
                                        <span>
                                            {availableChargers.length === 1 && availableChargers[0]._id === booking?.connector?._id ?
                                                <>
                                                    {/* {booking?.charger?.location?.locationName} -  */}
                                                    {booking?.charger?.chargerTag} {booking.connector.noOfConnectorsInCharger !== 1 ? ` - #${booking.connector.connectorNumber}` : ""} {` (${booking.connector.type}) `}
                                                </>
                                                :
                                                <>
                                                {
                                                    availableChargers.length === 0 ?
                                                        <>
                                                            No chargers Available
                                                        </>
                                                        :
                                                        <select
                                                            value={selectedCharger}
                                                            onChange={(e) => setSelectedCharger(e.target.value)}
                                                            className={styles.chargerSelect}
                                                        >
                                                            {/* <option>
                                                    {booking?.charger?.location?.locationName} - {booking?.charger?.chargerTag}
                                                </option> */}
                                                            {
                                                                
                                                                availableChargers.map((charger) => (
                                                                    <option value={charger._id} key={charger._id}>
                                                                        {/* {location?.locationName} -  */}
                                                                    {/* {(nightChargeAvailableConnectorIDs.includes(charger._id)) ? '🌙' : ""}  */}
                                                                    {charger.charger.chargerTag} {charger.noOfConnectorsInCharger !== 1 ? ` - #${charger.connectorNumber}` : ""} {` (${charger.type}) `}
                                                                    </option>
                                                                ))}

                                                        </select>
                                                }</>

                                            } 

                                        </span>
                                    </div>
                                    {
                                        availableChargers.length !== 0 ?
                                            <>
                                                <div>
                                                    Start Time : <span>{currentTime}</span>
                                                </div>
                                                <div>
                                                    Prior Estimated Amount : <span>${booking?.estimateAmount?.toFixed(2)}</span>
                                                </div>
                                                <div>
                                                    Amount needed for extra time : <span>${updatedWallet?.newEstimateAmountUpdated?.toFixed(2) < 0 ? 0.00 : updatedWallet?.newEstimateAmountUpdated?.toFixed(2)}</span>
                                                </div>
                                                <div>
                                                    New Estimated Amount : <span>${updatedWallet?.updatedEstimateAmount?.toFixed(2)}</span>
                                                </div>

                                                {(updatedWallet?.newWalletAmt <= 0 && !user?.isAutoPayEnabled) && <div className={styles['danger']}>
                                                    You don't have enough balance to update : <span>
                                                        <button className={styles['button']} onClick={() => setWalletRechargeModal(true)}>Add Amount</button>
                                                    </span>
                                                </div>}
                                            </>
                                            :
                                            <></>
                                    }
                                    {/* {updatedWallet?.newWalletAmt?.toFixed(2)} */}

                                    {(booking.isNightCharging) && <span>
                                       {nightChargeAvailableConnectorIDs.includes(selectedCharger) ?
                                        <p> <FaMoon color="#e09839ff"></FaMoon> Overnight Booking.</p> : 
                                        <p> Overnight booking not available for charger.</p>}
                                    </span>}
                                </>

                            }

                        </div>

                    }

                    {walletRechargeModal && <Modal open={walletRechargeModal} onCancel={() => { setWalletRechargeModal(!walletRechargeModal) }} footer={null}>
                        <StripePayment setWalletRechargeModal={setWalletRechargeModal} />
                    </Modal>}


                </Modal>}
            </div>
        </ConfigProvider>
    );
};

StartEarlier.propTypes = {
    user: PropTypes.object,
    userGroups: PropTypes.array,
    usersFreeChargingLocations: PropTypes.array,
    userAvgPower: PropTypes.object,
}
const startEarlierProps = state => ({
    user: state.auth && state.auth.user ? state.auth.user : null,
    userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
    usersFreeChargingLocations: state.auth && state.auth.user ? state.auth.user.freeChargingAllowedLocations : [],
    userAvgPower: state.auth && state.auth.user ? state.auth.user.avgPower : null,
})

export default connect(startEarlierProps, {})(StartEarlier);
